export const SNOWPACK_PUBLIC_VERSION = "1.1.0";
export const MODE = "production";
export const NODE_ENV = "production";
export const SSR = false;